module.exports = __webpack_public_path__ + "img/57.33c4f61d.png";